(() => {
  if (customElements.get('vl-stock-notice')) return;
  class StockNotice extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.dataset.stock !== 'coming-soon') return;
      this.ready = true;
      this.variantId = this.dataset.variantId;
      const subscribe = (attempt = 0) => {
        if (!this.isConnected) return;
        if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
          this.unsubscribe = window.MinimogEvents.subscribe(this.dataset.productId + '__VARIANT_CHANGE', variant => {
            if (variant && variant.id) this.variantId = String(variant.id);
          });
        } else if (attempt < 40) this.retry = setTimeout(() => subscribe(attempt + 1), 100);
      };
      subscribe();
      this.querySelector('[data-vl-notify]').addEventListener('click', async () => {
        const error = this.querySelector('[data-vl-notify-error]');
        error.hidden = true;
        try {
          const api = window._RestockRocket;
          if (!api || typeof api.openModal !== 'function') throw new Error('Signup unavailable');
          const product = JSON.parse(this.querySelector('[data-vl-notify-product]').textContent);
          const scope = this.closest('.shopify-section') || this.parentElement;
          const fields = Array.from(scope.querySelectorAll('input[type="radio"]:checked, select'));
          const options = product.options.map(option => {
            const name = typeof option === 'string' ? option : option.name;
            const field = fields.find(el => el.name === name || el.name === 'options[' + name + ']');
            return field && field.value;
          });
          const selected = options.every(Boolean) && product.variants.find(variant =>
            variant.options.every((value, index) => value === options[index]));
          const current = new URL(location.href).searchParams.get('variant');
          const urlVariant = product.variants.find(v => String(v.id) === current);
          const id = selected ? selected.id : urlVariant ? urlVariant.id : this.variantId;
          const variant = product.variants.find(v => String(v.id) === String(id)) || product.variants[0];
          await api.openModal(product, variant.id);
        } catch (_) { error.hidden = false; }
      });
    }
    disconnectedCallback() {
      clearTimeout(this.retry);
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }
  }
  customElements.define('vl-stock-notice', StockNotice);
})();

